export {default as Push} from 'design-system/src/Widget/Push/Push';
import Push from 'design-system/src/Widget/Push/Push';
export type {IPushProps} from 'design-system/src/Widget/Push/Push';
export default Push;
